<template>
    <div class="screen-wrapper-newbox">
      <div style="height: 80px; width: 100%" v-if="fromUser == 'guizhou'"></div>
      <div class="screenPhotovoltaicItem screenBg" id="screen">
        <div class="demo-root">
            <!-- <MyHeader> 
            </MyHeader> -->
          <main class="main">
            <div class="demo-left">
              <indexLeft></indexLeft>
            </div>
            <div class="demo-center">
              <indexCenter></indexCenter>
            </div>
            <div class="demo-right">
              <indexRight></indexRight>
            </div>
            <!-- <div class="chd-l-bg"></div>
            <div class="chd-r-bg"></div> -->
            <div class="bg-box"></div>
          </main>
        </div>
        <!-- <myFooter></myFooter> -->
      </div>
    </div>
  </template>
  
  <script>
//   import MyHeader from "@/views/components/headerB.vue";
  import myFooter from "@/views/exposition/components/myFooter.vue";
  import { dataInterface } from "@/api/dataInterfaceApi";
  import indexLeft from "./components/smart2/indexLeft.vue";
  import indexCenter from "./components/smart2/indexCenter.vue";
  import indexRight from "./components/smart2/indexRight.vue";
  export default {
    components: {
    //   MyHeader,
      myFooter,
      indexLeft,
      indexCenter,
      indexRight,
    },
    data() {
      return {
        pageInterval: null,
        intervalNum: 40,
        intervalNumSet: 100,
        fromUser: "",
        options: [],
        showFullScreen: true,
        choosed: 1,
        nowDate: "", // 当前日期
        nowTime: "", // 当前时间
        nowWeek: "", // 当前星期
        value1: "",
        value2: "",
        value3: "",
        options: [],
        harbourid: "",
        choosetime: "",
        timetpye: "",
        timer: "",
        router: "",
        changeMapBtn: false,
        end: false,
      };
    },
    beforeCreate() {
      let fromPath = localStorage.getItem("bigScreen::fromPath");
      let playCount = parseInt(
        localStorage.getItem("bigScreen::playCount") || 0,
        10
      );
      if (fromPath && ++playCount >= 2) {
        localStorage.setItem("bigScreen::playCount", "0");
        localStorage.setItem("bigScreen::fromPath", "");
        location.reload();
      } else {
        localStorage.setItem("bigScreen::playCount", playCount + "");
      }
    },
    mounted() {
      // this.$EventBus.$on('isActiveEnd', (isActiveEnd) => {
      // 	if (isActiveEnd) {
      // 		this.end = false;
      // 	} else {
      // 		this.end = true;
      // 	}
      // })
      console.log("this.$route===========", this.$route);
      let { fromUser, scaleY } = this.$route.query;
      fromUser ? sessionStorage.setItem("fromUser", fromUser) : "";
      scaleY ? localStorage.setItem("bigScreen::scaleY", scaleY) : "";
  
      let that = this;
      this.fromUser = sessionStorage.getItem("fromUser");
      document.title = "移动能源光储充换车云一体化大屏";
      //初始化自适应  ----在刚显示的时候就开始适配一次
      that.handleScreenAuto();
      //绑定自适应函数   ---防止浏览器栏变化后不再适配
      window.onresize = function () {
        that.handleScreenAuto();
      };
  
    },
    deleted() {
      window.onresize = null;
    },
    methods: {
      changeHarBourid() {
        console.log(55566);
        localStorage.setItem("harbour_id", this.harbourid);
        // this.getFacility()
        this.$bus.$emit("onfangdiangonglv");
      },
      //数据大屏自适应函数
      handleScreenAuto() {
        const designDraftWidth = 1920; //设计稿的宽度
        const designDraftHeight = 1080; //设计稿的高度
        //根据屏幕的变化适配的比例
        const scale =
          document.documentElement.clientWidth /
            document.documentElement.clientHeight <
          designDraftWidth / designDraftHeight
            ? document.documentElement.clientWidth / designDraftWidth
            : document.documentElement.clientHeight / designDraftHeight;
        //缩放比例
  
        console.log(scale);
  
        // document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`;
        let scaleY = parseFloat(localStorage.getItem("bigScreen::scaleY")) || 1;
        if (sessionStorage.getItem("fromUser") == "guizhou") {
          document.querySelector("#screen").style.transform = `scale(${scale}, ${
            scale * 1.6
          }) translate(-50%)`;
        } else {
          document.querySelector("#screen").style.transform = `scale(${scale}, ${
            scale * scaleY
          }) translate(-50%)`;
        }
      },
    },
    destroyed() {
      clearInterval(this.pageInterval);
    },
  };
  </script>
  
  <style lang="scss" scope>
  @import "@/assets/scss/pc.scss";
  @import "@/assets/scss/main-map.scss";
  @font-face {
    font-family: "DS-Digital-Bold";
    src: url("~@/assets/font/DS-Digital-Bold.ttf");
  }
  
  .main {
    position: relative;
    .demo-left {
      position: absolute;
      left: 30px;
      z-index: 10;
      bottom: 0;
      // background: red;
      height: 100%;
      padding-top: 70px;
      // background: skyblue;
    }
    .demo-center {
      width: 100%;
      height: 100%;
      // background: red;
    }
    .demo-right {
      position: absolute;
      right: 30px;
      z-index: 10;
      bottom: 0;
      // background: black;
      height: 100%;
      padding-top: 70px;
    }
  //   .chd-l-bg,
  //   .chd-r-bg {
  //     position: absolute;
  //     height: 100%;
  //     width: 1366px;
  //     opacity: 0.6;
  //   }
  //   .chd-l-bg {
  //     left: 0;
  //     background: url("~@/assets/images/exposition/chd-l-bg.png");
  //     background-size: 100% 100%;
  //   }
  //   .chd-r-bg {
  //     right: 0;
  //     background: url("~@/assets/images/exposition/chd-r-bg.png");
  //     background-size: 100% 100%;
  //     opacity: 0.5;
  //   }
      .bg-box{
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 9;
          background: url("~@/assets/images/smart/smartBg.png") no-repeat;
          background-size: 100%;
          pointer-events: none; 
      }
  }
  
  .screen-wrapper-newbox {
    height: 100%;
    width: 100%;
    font-size: 16px;
    color: #ffffff;
    .DS-Digital-Bold {
      font-family: "DS-Digital-Bold";
    }
    .screenPhotovoltaicItem {
      overflow: hidden;
      display: inline-block;
      width: 1920px;
      height: 1080px;
      transform-origin: 0 0;
      position: absolute;
      left: 0%;
      // background: red;
      .demo-root {
        header {
          width: 1920px;
          // height: 70px;
          text-align: center;
          .clickBack{
              width:150.95px;
              height:47px;
              margin-left: -300px;
              margin-top: 50px;
              img{
                  width: 100%;
                  height: 100%;
              }
          }
        }
        main {
          display: flex;
          // background: red;
          height: 100%;
          .demo-center {
            // width: 1940px;
            flex: 1;
          }
        }
        // footer{
        //     width: 100%;
        //     height: 100px;
        //     font-size: 40px;
        //     text-align: center;
        //     line-height: 100px;
        //     background: rgba(19, 211, 115, 0.3);
        // }
      }
    }
  }
  </style>